export default __webpack_public_path__ + "static/combined-3-banner-a615ac273748143b5c78bde581264f1c.svg";